module.exports = __webpack_public_path__ + "img/3.1f2f010f.png";